import styled from 'styled-components';

const NotFoundContainer = styled.main`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100%;
`;

export default NotFoundContainer;
